import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatTooltipModule
} from "@angular/material";
import { WorkflowStepDisclaimerComponent } from './workflow-step-disclaimer.component';
import { TranslateModule } from "@ngx-translate/core";
import {AppRoutingModule} from "../../app-routing.module";
import {MatGridListModule} from '@angular/material/grid-list';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DeleteDisclaimerTemplateComponent } from './delete-disclaimer-template/delete-disclaimer-template.component';
import {AddHotspotDotDialogComponent} from '../workflow-hotspot-creator/workflow-hotspot-dot-setter/add-hotspot-dot-dialog/add-hotspot-dot-dialog.component';
import {UpdateHotspotDotDialogComponent} from '../workflow-hotspot-creator/workflow-hotspot-dot-setter/update-hotspot-dot-dialog/update-hotspot-dot-dialog.component';
import {MessageDialogComponent} from '../../dialog/message-dialog/message-dialog.component';
import {ChangeLinkByTocTreeComponent} from '../workflow-hotspot-creator/workflow-hotspot-dot-setter/update-hotspot-dot-dialog/change-link-by-toc-tree/change-link-by-toc-tree.component';
import {LoadHotspotTemplateComponent} from '../workflow-hotspot-creator/load-hotspot-template/load-hotspot-template.component';
import {DeleteHotspotTemplateComponent} from '../workflow-hotspot-creator/delete-hotspot-template/delete-hotspot-template.component';

@NgModule({
  declarations: [
    WorkflowStepDisclaimerComponent,
    DeleteDisclaimerTemplateComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TranslateModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule
  ],
  exports: [
    WorkflowStepDisclaimerComponent
  ],
  entryComponents: [
    DeleteDisclaimerTemplateComponent
   ]
})
export class WorkflowStepDisclaimerModule { }
